import axios from "axios";
import { PRESALE_API_URL } from '../config/config';
// API 호출 공통 코드
const api = axios.create({
    baseURL: PRESALE_API_URL,
})
export default api;